module.exports = __webpack_public_path__ + "static/media/asta_fantacalcio.f8efe503.png";